/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featurepersonalizeddesc2Inputs */

const zh_about_featurepersonalizeddesc2 = /** @type {(inputs: About_Featurepersonalizeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 智能辅导适应每位学生的节奏和水平，提供精准的答疑和练习，因材施教不再是口号。`)
};

const en_about_featurepersonalizeddesc2 = /** @type {(inputs: About_Featurepersonalizeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tutoring adapts to each student's pace and level, providing precise Q&A and exercises — making differentiated instruction a reality, not just a slogan.`)
};

const es_about_featurepersonalizeddesc2 = /** @type {(inputs: About_Featurepersonalizeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tutoría con IA se adapta al ritmo y nivel de cada estudiante, proporcionando preguntas y ejercicios precisos, haciendo de la instrucción diferenciada una realidad.`)
};

/**
* | output |
* | --- |
* | "AI tutoring adapts to each student's pace and level, providing precise Q&A and exercises — making differentiated instruction a reality, not just a slogan." |
*
* @param {About_Featurepersonalizeddesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featurepersonalizeddesc2 = /** @type {((inputs?: About_Featurepersonalizeddesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featurepersonalizeddesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featurepersonalizeddesc2(inputs)
	if (locale === "en") return en_about_featurepersonalizeddesc2(inputs)
	return es_about_featurepersonalizeddesc2(inputs)
});
export { about_featurepersonalizeddesc2 as "about_featurePersonalizedDesc" }